import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from '../commons/dialog/dialog.component';

// Services
import { BlogService } from '../../services/blog.service';
import { ModuleService } from '../../services/modules.service';

// Model
import { Blog } from '../../models/blog';

// Mockup
import { IoNewsMockup } from './io-news.mockup';

import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-io-news',
  templateUrl: './io-news.component.html',
  styleUrls: ['./io-news.component.scss', './io-news.component.medium.scss']
})
export class IoNewsComponent implements OnInit {

  isLoadingBlogs = false;

  blogsArray = [];

  private sub: any;

  get isBlogsEmpty() {
    return this.blogsArray.length ? false : true;
  }

  get isAboutIoAvailable() {
    return this.moduleService.isAboutIoAvailable();
  }

  get getDefaultImg() {
    return null;
  }

  itemsPerPageArray = [2, 5, 10, 15, 20];

  // Pagination variables
  public totalItems = null;
  public currentPage = 1;
  public itemsPerPage = 5;

  constructor(
    private blogService: BlogService,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private sanitizer: DomSanitizer,
    private moduleService: ModuleService
  ) { }

  ngOnInit() {


    // Set loading flags
    this.isLoadingBlogs = true;

    // Init objects with Mocks
    this.blogsArray = IoNewsMockup.blogsArrayBE;

    // Init URL parameters from query
    this.initUrlParams();

  }

  OnDestroy() {
    this.sub.unsubscribe();
  }

  initUrlParams() {
    this.sub = this.route
      .queryParams
      .subscribe(params => {
        this.currentPage = +params.page || 1;
        this.itemsPerPage = +params.size || 10;
        this.getBlogs();
      });
  }

  getImgUrl(id: any) {
    return `${environment.url.onlineResourcesStaticUrl}${id}.jpg`;
  }

  imgError(e) {
    //why is this empty?
  }

  getBlogs() {
    this.isLoadingBlogs = true;
    // Parameter Object
    const obj = {
      page: this.currentPage - 1,
      size: this.itemsPerPage
    };
    const blogs: any = this.blogService.getBlogList(obj);

    blogs
      .$observable
      .subscribe(() => {
        this.blogsArray = [];
        blogs.content.forEach(blog => {
          this.blogsArray.push(new Blog(blog));
        });
        this.totalItems = blogs.page.totalElements;
        // Workaround for setting a new current page when pagination is finally loaded
        setTimeout(() => {
          this.currentPage = blogs.page.number + 1; // number of page + 1
        });

        this.isLoadingBlogs = false;
      },
      err => {
        const data = { message: 'Connection Problems. Try again please' };
        this.dialog.open(DialogComponent, { data });
        this.router.navigate(['/error']);
        throw err;
      }
      );
  }

  public navigate() {
    this.router.navigate(['/io-news'], {
      queryParams: {
        page: this.currentPage,
        size: this.itemsPerPage
      }
    });
  }

  public pageChanged(event: any): void {
    this.currentPage = event.page;
    this.navigate();
  }

  public changeSize() {
    this.currentPage = 1;
    this.navigate();
  }

  goToBlog(id) {
    this.router.navigate(['/io-news/', id]);
  }

}
